import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface QuantityStepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  label: string;
}
export function QuantityStepper({
  value,
  onChange,
  min = 1,
  max = 10,
  label
}: QuantityStepperProps) {
  return <div role="group" aria-label={label} className="inline-flex items-center rounded-[3px] border border-line-strong bg-surface" data-id="element-560" data-mp="gamirzm5c94d">
      <button type="button" className="inline-flex h-11 w-11 items-center justify-center text-ink transition-colors duration-150 ease-out hover:bg-canvas disabled:opacity-40" onClick={() => onChange(value - 1)} disabled={value <= min} aria-label="Decrease quantity" data-id="element-561" data-mp="141i72mre8m6v">
        <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-562" data-mp="z402f8kest4o" />
      </button>
      <output aria-live="polite" className="w-10 text-center text-[15px] font-medium tabular-nums" data-id="element-563" data-mp="3erglkhguuyrk">
        {value}
      </output>
      <button type="button" className="inline-flex h-11 w-11 items-center justify-center text-ink transition-colors duration-150 ease-out hover:bg-canvas disabled:opacity-40" onClick={() => onChange(value + 1)} disabled={value >= max} aria-label="Increase quantity" data-id="element-564" data-mp="3jprw6uez5dau">
        <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-565" data-mp="1ijtwweuz575a" />
      </button>
    </div>;
}